import FormField from './FormField'
import React, {useState, useEffect} from 'react'

type DynamicFormFieldProps = {
  value?: string
  onSubmit?: (value: string) => void
  onBlur?: (value: string) => void
  onEdit?: (value: string) => void
  formatValue?: (value: string) => string
} & Omit<React.ComponentProps<typeof FormField>, 'onSubmit' | 'value'>

const DynamicFormField: React.FC<DynamicFormFieldProps> = ({value: initialValue, formatValue, onSubmit, onBlur, onEdit, ...props}) => {
  const [value, setValue] = useState(() => {
    if (initialValue && formatValue) {
      return formatValue(initialValue)
    }
    return initialValue || ''
  })

  useEffect(() => {
    if (initialValue !== undefined) {
      setValue(formatValue ? formatValue(initialValue) : initialValue)
    }
  }, [initialValue, formatValue])

  return (
    <FormField
      {...props}
      value={value}
      onBlur={() => (onBlur ? onBlur(value) : undefined)}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        if (formatValue) {
          setValue(formatValue(e.target.value))
          if (onEdit) onEdit(formatValue(e.target.value))
          return
        }
        setValue(e.target.value)
        if (onEdit) onEdit(e.target.value)
      }}
      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          e.stopPropagation()
          if (onSubmit) onSubmit(value)
          e.currentTarget.blur()
          return
        }

        props?.onKeyDown?.(e)
      }}
    />
  )
}

export default DynamicFormField
